import { render, staticRenderFns } from "./renderModel.vue?vue&type=template&id=48676909&scoped=true"
import script from "./renderModel.vue?vue&type=script&lang=js"
export * from "./renderModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48676909",
  null
  
)

export default component.exports